export const REQUEST = (actionType) => `${actionType}_REQ`;
export const SUCCESS = (actionType) => `${actionType}_RESP`;
export const ERROR = (actionType) => `${actionType}_ERR`;
export const CLEAR = (actionType) => `${actionType}_CLEAR`;
